import Wordpress from "squde-wp-api";

export function wp() {
    return new Wordpress("https://squde.nl/wp-json/wp/v2/");
}